var map = {
	"./bear-color.png": 5459,
	"./bull-color.png": 31326,
	"./butterfly-color.png": 86920,
	"./camel-color.png": 46443,
	"./cat-color.png": 45113,
	"./cobra-color.png": 70234,
	"./cow-color.png": 1084,
	"./crocodile-color.png": 18733,
	"./deer-color.png": 93869,
	"./dog-color.png": 31199,
	"./donkey-color.png": 78241,
	"./eagle-color.png": 2401,
	"./elephant-color.png": 57970,
	"./galo-color.png": 72690,
	"./goat-color.png": 11688,
	"./horse-color.png": 62714,
	"./lion-color.png": 66791,
	"./monkey-color.png": 53054,
	"./ostrich-color.png": 49597,
	"./peacock-color.png": 21255,
	"./pig-color.png": 48713,
	"./rabbit-color.png": 83973,
	"./ram-color.png": 2861,
	"./tiger-color.png": 21948,
	"./turkey-color.png": 41655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38654;